import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_property_key } from "@swc/helpers/_/_to_property_key";
import { handleActions } from 'redux-actions';
import camelCase from 'lodash/camelCase';
import { updateModule, purgeAllModules, fetchModulesSuccess, fetchModuleSuccess, fetchModuleEndpoint, fetchModuleEndpointSuccess, fetchModuleEndpointError, fetchModuleEndpointPurgeData } from '../actions/modules';
import { removeModuleSuccess } from '../actions/layout';
const defaultState = {};
export default handleActions({
    [fetchModulesSuccess.toString()]: (state, action)=>{
        const { modules } = action.payload;
        return _object_spread({}, state, (modules || []).reduce((result, current)=>{
            result[current.id] = current;
            return result;
        }, {}));
    },
    [fetchModuleSuccess.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            [action.payload.id]: _object_spread({}, action.payload)
        }),
    [removeModuleSuccess.toString()]: (state, action)=>{
        const _action_payload_moduleId = action.payload.moduleId, { [_action_payload_moduleId]: remove } = state, rest = _object_without_properties(state, [
            _action_payload_moduleId
        ].map(_to_property_key));
        return rest;
    },
    [updateModule.toString()]: (state, action)=>{
        var _state_action_payload_id, _state_action_payload_id_moduleData, _state_action_payload_id1, _state_action_payload_id_moduleData1, _state_action_payload_id2, _state_action_payload_id3, _state_action_payload_id4;
        return _object_spread_props(_object_spread({}, state), {
            [action.payload.id]: _object_spread_props(_object_spread({}, state[action.payload.id] || {}), {
                moduleData: _object_spread_props(_object_spread({}, ((_state_action_payload_id = state[action.payload.id]) === null || _state_action_payload_id === void 0 ? void 0 : _state_action_payload_id.moduleData) || {}), {
                    [camelCase((_state_action_payload_id1 = state[action.payload.id]) === null || _state_action_payload_id1 === void 0 ? void 0 : (_state_action_payload_id_moduleData = _state_action_payload_id1.moduleData) === null || _state_action_payload_id_moduleData === void 0 ? void 0 : _state_action_payload_id_moduleData.dataKey)]: _object_spread({}, ((_state_action_payload_id3 = state[action.payload.id]) === null || _state_action_payload_id3 === void 0 ? void 0 : _state_action_payload_id3.moduleData[camelCase((_state_action_payload_id2 = state[action.payload.id]) === null || _state_action_payload_id2 === void 0 ? void 0 : (_state_action_payload_id_moduleData1 = _state_action_payload_id2.moduleData) === null || _state_action_payload_id_moduleData1 === void 0 ? void 0 : _state_action_payload_id_moduleData1.dataKey)]) || {}, action.payload.moduleData || {})
                }),
                moduleMeta: _object_spread({}, ((_state_action_payload_id4 = state[action.payload.id]) === null || _state_action_payload_id4 === void 0 ? void 0 : _state_action_payload_id4.moduleMeta) || {}, action.payload.moduleMeta || {})
            })
        });
    },
    [fetchModuleEndpointPurgeData.toString()]: (state, action)=>{
        var _state_action_payload_id;
        return _object_spread_props(_object_spread({}, state), {
            [action.payload.id]: _object_spread_props(_object_spread({}, state[action.payload.id]), {
                requests: _object_spread_props(_object_spread({}, ((_state_action_payload_id = state[action.payload.id]) === null || _state_action_payload_id === void 0 ? void 0 : _state_action_payload_id.requests) || {}), {
                    [action.payload.path]: undefined
                })
            })
        });
    },
    [fetchModuleEndpoint.toString()]: (state, action)=>{
        var _state_action_payload_id;
        return _object_spread_props(_object_spread({}, state), {
            [action.payload.id]: _object_spread_props(_object_spread({}, state[action.payload.id]), {
                requests: _object_spread_props(_object_spread({}, ((_state_action_payload_id = state[action.payload.id]) === null || _state_action_payload_id === void 0 ? void 0 : _state_action_payload_id.requests) || {}), {
                    [action.payload.path]: {
                        path: action.payload.path,
                        response: undefined,
                        isFetching: true,
                        errorDescription: undefined,
                        ts: Date.now()
                    }
                })
            })
        });
    },
    [fetchModuleEndpointSuccess.toString()]: (state, action)=>{
        var _action_payload_response_config, _action_payload_response, _action_payload, _state_action_payload_id, _state_action_payload_id_requests, _state_action_payload_id1;
        return _object_spread_props(_object_spread({}, state), {
            [action.payload.id]: _object_spread_props(_object_spread({}, state[action.payload.id]), {
                version: ((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : (_action_payload_response = _action_payload.response) === null || _action_payload_response === void 0 ? void 0 : (_action_payload_response_config = _action_payload_response.config) === null || _action_payload_response_config === void 0 ? void 0 : _action_payload_response_config.version) || state[action.payload.id].version,
                requests: _object_spread_props(_object_spread({}, ((_state_action_payload_id = state[action.payload.id]) === null || _state_action_payload_id === void 0 ? void 0 : _state_action_payload_id.requests) || {}), {
                    [action.payload.path]: _object_spread_props(_object_spread({}, ((_state_action_payload_id1 = state[action.payload.id]) === null || _state_action_payload_id1 === void 0 ? void 0 : (_state_action_payload_id_requests = _state_action_payload_id1.requests) === null || _state_action_payload_id_requests === void 0 ? void 0 : _state_action_payload_id_requests[action.payload.path]) || {}), {
                        path: action.payload.path,
                        response: action.payload.response,
                        isFetching: false,
                        errorDescription: undefined
                    })
                })
            })
        });
    },
    [fetchModuleEndpointError.toString()]: (state, action)=>{
        var _state_action_payload_id, _state_action_payload_id_requests, _state_action_payload_id1;
        return _object_spread_props(_object_spread({}, state), {
            [action.payload.id]: _object_spread_props(_object_spread({}, state[action.payload.id]), {
                requests: _object_spread_props(_object_spread({}, ((_state_action_payload_id = state[action.payload.id]) === null || _state_action_payload_id === void 0 ? void 0 : _state_action_payload_id.requests) || {}), {
                    [action.payload.path]: _object_spread_props(_object_spread({}, ((_state_action_payload_id1 = state[action.payload.id]) === null || _state_action_payload_id1 === void 0 ? void 0 : (_state_action_payload_id_requests = _state_action_payload_id1.requests) === null || _state_action_payload_id_requests === void 0 ? void 0 : _state_action_payload_id_requests[action.payload.path]) || {}), {
                        path: action.payload.path,
                        response: action.payload.response,
                        isFetching: false,
                        errorDescription: action.payload.errorDescription
                    })
                })
            })
        });
    },
    [purgeAllModules.toString()]: ()=>({})
}, defaultState);

//# sourceMappingURL=modules.js.map